import React from 'react';
interface CustomSelectProps {
  id: string;
  value: any;
  defaultValue?: any;
  onChange: any;
  className: string;
  options: any;
  isDummyOption?: boolean;
  isAllOption?: boolean;
  firstOption?: string;
  firstUserOption?: string;
}
export default function CustomSelect({
  className,
  id,
  value,
  defaultValue,
  onChange,
  options,
  isDummyOption,
  isAllOption,
  firstOption,
  firstUserOption,
}: CustomSelectProps) {
  return (
    <select
      className={`${className} ${value || defaultValue ? 'highlighted-border' : ''}`}
      id={id}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      data-dselect-search='true'
    >
      {isDummyOption && <option value={'-1'}>Select a value</option>}
      {isAllOption && <option value={'-1'}>All</option>}
      {firstOption && <option value=''>{firstOption}</option>}
      {firstUserOption && <option value='-1'>{firstUserOption}</option>}
      {options &&
        options.length > 0 &&
        options.map((option: any) => (
          <option key={option.id} value={option.id}>
            {option.name
              ? option.name
              : `${option?.first_name} ${option?.last_name}`}
          </option>
        ))}
    </select>
  );
}
